import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import { brandColours, minBreakpointQuery, sectionMargins } from '../styles';
import { Container, Heading } from './ui';
import CardSlider from './CardSlider';
import SpaCard from './SpaCard';
import { StoreContext } from '../context/StoreContext';

const StyledRecentlyViewed = styled.section`
  ${sectionMargins()};
`;

const StyledInner = styled.div`
  position: relative;
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;
  padding-right: 160px;

  ${minBreakpointQuery.small`
    margin-bottom: 30px;
    padding-right: 180px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 40px;
  `}
`;

const StyledItems = styled.div`
  display: grid;
  grid-template-columns: 100%;
  gap: 20px;

  ${minBreakpointQuery.mlarge`
    grid-template-columns: repeat(3, calc((100% - 40px) / 3));
  `}
`;

const StyledItemsSlider = styled(CardSlider)`
  ${({ onlyThree }) => {
    if (onlyThree) {
      return css`
        .card-slider-position {
          ${minBreakpointQuery.mlarge`
            display: none;
          `}
        }
      `;
    }
  }}
`;

const StyledItem = styled(SpaCard)`
  color: ${brandColours.primary};
  height: 100%;
`;

const RecentlyViewed = ({ currentSpaId }) => {
  const { recentlyViewed: initialRecentlyViewed } = useContext(StoreContext);

  const recentlyViewed =
    initialRecentlyViewed &&
    initialRecentlyViewed
      .filter(({ spaId }) => spaId !== currentSpaId)
      .slice(0, 6);

  const ItemsComponent =
    recentlyViewed && recentlyViewed.length > 2
      ? StyledItemsSlider
      : StyledItems;

  return (
    recentlyViewed &&
    recentlyViewed.length > 0 && (
      <StyledRecentlyViewed>
        <Container>
          <StyledInner>
            <StyledHeading>Recently Viewed</StyledHeading>
            <ItemsComponent onlyThree={recentlyViewed.length === 3}>
              {recentlyViewed.map((item, id) => (
                <StyledItem
                  key={id}
                  {...item}
                  {...(item.spaRating && {
                    rating:
                      typeof item.spaRating === 'number'
                        ? item.spaRating
                        : item.spaRating.rating,
                  })}
                  {...((item.address || item.city) && {
                    location: `${item.address ? item.address.city : item.city}, ${
                      item.county.name
                    }`,
                  })}
                  {...((Array.isArray(item.packageCount) || item.packages) && {
                    packageCount: item.packageCount
                      ? item.packageCount.length
                      : item.packages,
                  })}
                  isRecentlyViewed={true}
                />
              ))}
            </ItemsComponent>
          </StyledInner>
        </Container>
      </StyledRecentlyViewed>
    )
  );
};

export default RecentlyViewed;
